export const LAST_CALENDAR_DAY_INDEX = 27;

export const ScheduleViewEnum = {
  MY: 'my',
  ALL: 'all',
};
